import { ScreenContext } from '@/contexts/ScreenContext';
import { useContext } from 'react';

export const useRwdUI = () => {
    const { scaleFactor } = useContext(ScreenContext);

    /**
     *
     * Use in useEffect, 'scaleFactor' needs to be added in the dependencies array
     */
    const pxToRwdNumber = (px: number) => {
        return px * scaleFactor;
    };

    /**
     *
     * Use in useEffect, 'scaleFactor' needs to be added in the dependencies array
     */
    const pxToRwdString = (px: number) => {
        return `${px * scaleFactor}px`;
    };
    const pxToRwdCSSString = (px: number) => {
        return `calc(${px}px * var(--global-scale-factor))`;
    };
    return { pxToRwdNumber, pxToRwdString, pxToRwdCSSString };
};
